var React = require('react');

function WeedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.34 37.94C29.319 26.4502 28.862 10.3228 24 0C19.13 10.34 18.68 26.53 22.66 37.94C18.26 28.45 8.73 18.19 0 13.8799C3.2103 23.3275 12.5331 34.4063 21.57 39.8899C15.79 37.1899 7.59 36.3699 1.95 38.1199C7.4058 41.6931 16.7404 43.1193 23.23 41.4499V49.2999H24.77V41.45C31.2585 43.1191 40.5926 41.6942 46.05 38.12C40.41 36.37 32.21 37.19 26.43 39.89C35.3447 34.4806 44.7483 23.4492 48 13.88C39.27 18.19 29.74 28.45 25.34 37.94Z","fill":"black"}));
}

WeedInline.defaultProps = {"width":"48","height":"50","viewBox":"0 0 48 50","fill":"none"};

module.exports = WeedInline;

WeedInline.default = WeedInline;
